export const DEBUG = false;
